import { CopyOutlined, InfoCircleOutlined, UserOutlined, CheckOutlined } from "@ant-design/icons";
import { Input, Tooltip, message } from "antd";
import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  GabIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  ThreadsIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
  XIcon,
  BlueskyIcon,
  FacebookShareCount,
} from "react-share";
import {
  EmailShareButton,
  FacebookShareButton,
  GabShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  ThreadsShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from "react-share";
import { useState } from "react";

export function AlumniUrl(props) {
  const { alumniHandle } = props;
  const [copied, setCopied] = useState(false);
  const url = `https://alumni.gnomon.edu/${alumniHandle}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      message.success('URL copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      message.error('Failed to copy URL');
    }
  };

  return (
    <>
      <div className="_f">
        <div className="_fv _f100">
          <h1>Share page</h1>

          <div className="_f _fm _fgap14 _fwrap _f100 ">
            <Input
              className="alumni-url-input"
              value={url}
              // prefix={<UserOutlined style={{ color: 'rgb(254, 254, 254)' }} />}
              suffix={
                <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
                  <div onClick={handleCopy} style={{ cursor: 'pointer' }}>
                    {copied ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CopyOutlined style={{ color: 'rgba(255, 255, 255, 0.45)' }} />
                    )}
                  </div>
                </Tooltip>
              }
            />

            <EmailShareButton url={url} className="share-button angle">
              <EmailIcon size={36} round={false} iconFillColor="#ffd40b" bgStyle={{ fill: '#2b2b2b' }} />
            </EmailShareButton>

            <LinkedinShareButton url={url} className="share-button angle">
              <LinkedinIcon size={36} round={false} iconFillColor="#ffd40b" bgStyle={{ fill: '#2b2b2b' }} />
            </LinkedinShareButton>

            <FacebookShareButton url={url} className="share-button angle">
              <FacebookIcon size={36} round={false} iconFillColor="#ffd40b" bgStyle={{ fill: '#2b2b2b' }} />
            </FacebookShareButton>

            <TwitterShareButton url={url} className="share-button angle">
              <TwitterIcon size={36} round={false} iconFillColor="#ffd40b" bgStyle={{ fill: '#2b2b2b' }} />
            </TwitterShareButton>

            <WhatsappShareButton url={url} className="share-button angle">
              <WhatsappIcon size={36} round={false} iconFillColor="#ffd40b" bgStyle={{ fill: '#2b2b2b' }} />
            </WhatsappShareButton>

            <TelegramShareButton url={url} className="share-button angle">
              <TelegramIcon size={36} round={false} iconFillColor="#ffd40b" bgStyle={{ fill: '#2b2b2b' }} />
            </TelegramShareButton>

          </div>
        </div>
      </div>
    </>
  )
}
